import { ElementType } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Dashboard from "../../client/pages/dashboard/Dashboard";
import ActivePatient from "../../client/pages/patient/viewpatient/activepatient/ActivePatient";
import DeactivePatient from "../../client/pages/patient/viewpatient/deactivepatient/DeactivePatient";
import QuickAddPatient from "../../client/pages/patient/addpatient/quickadd/QuickAddPatient";
import FullregisterPatient from "../../client/pages/patient/addpatient/fullregistration/FullregisterPatient";
import General from "../../client/pages/patient/patientone/general/General";
import Medical from "../../client/pages/patient/patientone/mediacal/Medical";
import Appointments from "../../client/pages/patient/patientone/appointment/Appointments";
import Invoices from "../../client/pages/patient/patientone/invoices/Invoices";
import Examination from "../../client/pages/patient/patientone/examination/Examination";
import  ClinicManagementPage  from "../../client/pages/bookui/ClinicManagementPage";
import AllBrand from "../../client/pages/inventory/brand/allBrand/AllBrand";
import AllProduct from "../../client/pages/inventory/product/allProduct/AllProduct";
import AllCategory from "../../client/pages/inventory/category/allCategory/AllCategory";
import AllSupplier from "../../client/pages/inventory/supplier/allSupplier/AllSupplier";
import AddPurchase from "../../client/pages/inventory/purchase/addPurchase/AddPurchase";
import AllRelease from "../../client/pages/inventory/productRelease/allRelease/AllRelease";
import AddRelease from "../../client/pages/inventory/productRelease/addRelease/AddRelease";
import AllPurchase from "../../client/pages/inventory/purchase/allPurchase/AllPurchase";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import InventoryIcon from "@mui/icons-material/Inventory";
import MyAppointment from "../../client/pages/myaccount/myappointments/MyAppointment";
import EventIcon from "@mui/icons-material/Event";
import ManagePrint from "../../client/pages/setting/manageprint/ManagePrint";
import Managetime from "../../client/pages/setting/managetime/Managetime";
import ManagePurpose from "../../client/pages/setting/managepurpose/ManagePurpose";
import TreatmentAllList from "../../client/pages/manage/managetreatment/treatmentlist/TreatmentAllList";
import DeactiveTreatmentList from "../../client/pages/manage/managetreatment/deactiveTreatmentlist/DeactiveTreatmentList";
import DiagnoseList from "../../client/pages/manage/managediagnosis/diagnoselist/DiagnoseList";
import AddDiagnose from "../../client/pages/manage/managediagnosis/adddiagnose/AddDiagnose";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import Drugs from "../../client/pages/setting/drugs/Drugs";
import SettingsIcon from "@mui/icons-material/Settings";
import Invoice from "../../client/pages/payment/invoice/Invoice";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AllLastPayments from "../../client/pages/payment/payments/allpayments/AllLastPayments";
import ShouldBePaid from "../../client/pages/payment/payments/shouldbepaid/ShouldBePaid";
import Advanced from "../../client/pages/payment/payments/advanced/Advanced";
import Completed from "../../client/pages/payment/payments/completed/Completed";
import AllPaymentList from "../../client/pages/payment/paymentList/AllPaymentList";
import Roles from "../../client/pages/staff/role/roles/Roles";
import GroupsIcon from "@mui/icons-material/Groups";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AddRole from "../../client/pages/staff/role/addRole/AddRole";
import DeactiveRole from "../../client/pages/staff/role/deactiveroles/DeactiveRole";
import Employees from "../../client/pages/staff/employee/employees/Employees";
import AddEmployee from "../../client/pages/staff/employee/addemployee/AddEmployee";
import DeactiveEmployee from "../../client/pages/staff/employee/deactiveEmployee/DeactiveEmployee";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import PatientOne from "../../client/pages/patient/patientone/PatientOne";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import TreatmentList from "../../client/pages/examinations/viewTreatments/TreatmentList";
import AddTreatment from "../../client/pages/manage/alltreatments/addtreatment/AddTreatment";
import Diagnose from "../../client/pages/manage/alltreatments/addtreatment/diagnose/Diagnose";
import TreatmentTable from "../../client/pages/manage/alltreatments/addtreatment/treatmenttable/TreatmentTable";
import PastTreatment from "../../client/pages/manage/alltreatments/addtreatment/pasttreatment/PastTreatment";
import Prescription from "../../client/pages/manage/alltreatments/addtreatment/prescription/Prescription";
import TreatmentPlan from "../../client/pages/manage/alltreatments/addtreatment/treatmentplan/TreatmentPlan";
import AllAppointment from "../../client/pages/appointment/viewappointment/allAppointment/AllAppointment";
import MakeAppointment from "../../client/pages/appointment/makeappointment/MakeAppointment";
import YourAppointment from "../../client/pages/appointment/viewappointment/yourAppointment/YourAppointment";
type Route = {
  TITLE: string;
  MAINTITLE?: string;
  ICON?: ElementType; // For React component icons
  KEY: number;
  PATH: string;
  DISABLED?: boolean;
  ELEMENT?: ElementType; // For React page components like Dashboard, Employee, etc.
  DIRECT?: boolean;
  SUBNAV?: Route[]; // Recursive for nested menus
  SUBSUBNAV?: Route[]; // Further nesting if needed
};
export const NEWROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    ICON: DashboardIcon,
    KEY: 1,
    PATH: "dashboard",
    ELEMENT: Dashboard,
  },
  {
    TITLE: "Patients",
    ICON: PeopleAltIcon,
    KEY: 2,
    PATH: "patients",
    DIRECT: true,
    SUBNAV: [
      // {
      //   TITLE: "Add Patient",
      //   ICON: PersonAddIcon,
      //   KEY: 21,
      //   PATH: "add-patient",
      //   DIRECT: true,
      //   SUBNAV: [
      //     {
      //       TITLE: "Quick Add",
      //       ICON: PersonAddIcon,
      //       KEY: 211,
      //       PATH: "quick-add",
      //       ELEMENT: QuickAddPatient,
      //     },
      //     {
      //       TITLE: "Full Registration",
      //       ICON: PersonAddIcon,
      //       KEY: 212,
      //       PATH: "full-registration",
      //       ELEMENT: FullregisterPatient,
      //     },
      //   ],
      // },
      {
        TITLE: "Quick Add",
        ICON: PersonAddIcon,
        KEY: 211,
        PATH: "quick-add",
        ELEMENT: QuickAddPatient,
      },
      {
        TITLE: "Full Registration",
        ICON: PersonAddIcon,
        KEY: 212,
        PATH: "full-registration",
        ELEMENT: FullregisterPatient,
      },
      {
        TITLE: "Patients List",
        ICON: FormatListBulleted,
        KEY: 22,
        PATH: "patients-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "Active",
            KEY: 221,
            PATH: "active",
            ELEMENT: ActivePatient,
          },
          {
            TITLE: "Deactive",
            KEY: 222,
            PATH: "deactive",
            ELEMENT: DeactivePatient,
          },
        ],
      },
      {
        TITLE: "Edit Patient",
        ICON: PeopleAltIcon,
        KEY: 23,
        PATH: "edit-patients/:ID",
        ELEMENT: FullregisterPatient,
        DIRECT: true,
        DISABLED: true,
      },
      {
        TITLE: "Patient Details",
        ICON: PeopleAltIcon,
        KEY: 24,
        PATH: "patientone",
        DIRECT: true,
        ELEMENT: PatientOne,
        DISABLED: true,
        SUBNAV: [
          {
            TITLE: "General Detail",
            KEY: 241,
            PATH: "general-detail/:ID",
            ELEMENT: General,
          },
          {
            TITLE: "Examination Detail",
            KEY: 242,
            PATH: "examination/:ID",
            ELEMENT: Examination,
          },
          {
            TITLE: "Medical History Detail",
            KEY: 243,
            PATH: "medical-history/:ID",
            ELEMENT: Medical,
          },
          {
            TITLE: "Invoices Detail",
            KEY: 245,
            PATH: "invoices/:ID",
            ELEMENT: Invoices,
            DISABLED: true,
          },
          {
            TITLE: "Appointments Detail",
            KEY: 244,
            PATH: "appointments/:ID",
            ELEMENT: Appointments,
            DISABLED: true,
          },
        ],
      },
    ],
  },
  {
    TITLE: "Treatments",
    ICON: MedicalServicesIcon,
    KEY: 3,
    PATH: "treatment-diagnose",
    DIRECT: true,
    DISABLED: true,
    SUBNAV: [
      {
        TITLE: "View Treatments",
        ICON: FormatListBulletedIcon,
        KEY: 31,
        PATH: "view-treatments",
        ELEMENT: TreatmentList,
        DISABLED: true,
        DIRECT: false,
      },
      {
        TITLE: "Treatment",
        ICON: MedicalServicesIcon,
        KEY: 32,
        PATH: "add-treatment",
        DIRECT: true,
        ELEMENT: AddTreatment,
        DISABLED: true,
        SUBNAV: [
          {
            TITLE: "Diagnose",
            KEY: 321,
            PATH: "diagnose/:ID",
            ELEMENT: Diagnose,
          },
          {
            TITLE: "Treatment Table",
            KEY: 322,
            PATH: "treatment-table/:ID",
            ELEMENT: TreatmentTable,
          },
          {
            TITLE: "Past Treatment",
            KEY: 323,
            PATH: "past-treatment/:ID",
            ELEMENT: PastTreatment,
          },
          {
            TITLE: "Prescription",
            KEY: 324,
            PATH: "drugs/:ID",
            ELEMENT: Prescription,
          },
          {
            TITLE: "Treatment Plan",
            KEY: 325,
            PATH: "treatment-planned/:ID",
            ELEMENT: TreatmentPlan,
          },
        ],
      },
    ],
  },
  {
    TITLE: "Payments",
    ICON: ReceiptIcon,
    KEY: 4,
    PATH: "payments",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Create Invoice",
        KEY: 41,
        PATH: "create-invoice",
        ELEMENT: Invoice,
      },
      {
        TITLE: "Invoice",
        KEY: 42,
        PATH: "invoice/:ID",
        ELEMENT: Invoice,
        DISABLED: true,
      },
      {
        TITLE: "Invoices List",
        KEY: 43,
        PATH: "invoices-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Invoices",
            KEY: 431,
            PATH: "all-invoices",
            ELEMENT: AllLastPayments,
          },
          {
            TITLE: "Due Invoices",
            KEY: 432,
            PATH: "due-invoices",
            ELEMENT: ShouldBePaid,
          },
          {
            TITLE: "Advance",
            KEY: 433,
            PATH: "advanced",
            ELEMENT: Advanced,
          },
          {
            TITLE: "Completed",
            KEY: 434,
            PATH: "completed",
            ELEMENT: Completed,
          },
        ],
      },
      {
        TITLE: "Payment List",
        KEY: 44,
        PATH: "payment-list",
        ELEMENT: AllPaymentList,
      },
    ],
  },
  {
    TITLE: "Make An Appointment",
    ICON: EventIcon,
    KEY: 6,
    PATH: "appointments",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Make An Appointment",
        ICON: EventIcon,
        KEY: 61,
        PATH: "make-appointment",
        ELEMENT: MakeAppointment,
      },
      {
        TITLE: "Appointments",
        ICON: EventIcon,
        KEY: 62,
        PATH: "view-appointment",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "My Appointment",
            KEY: 621,
            PATH: "my-appointment",
            ELEMENT: YourAppointment,
          },
          {
            TITLE: "All Appointment",
            KEY: 622,
            PATH: "all-appointment",
            ELEMENT: AllAppointment,
          },
        ],
      },
    ],
  },
  {
    TITLE: "My Appointment",
    ICON: EventIcon,
    KEY: 91,
    PATH: "my-appointment",
    ELEMENT: MyAppointment,
  },
  {
    TITLE: "Inventory",
    ICON: InventoryIcon,
    KEY: 8,
    PATH: "inventory",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Category",
        KEY: 81,
        PATH: "category",
        ELEMENT: AllCategory,
      },
      {
        TITLE: "Product",
        KEY: 82,
        PATH: "product",
        ELEMENT: AllProduct,
      },
      {
        TITLE: "Brand",
        KEY: 83,
        PATH: "brand",
        ELEMENT: AllBrand,
      },
      {
        TITLE: "Supplier",
        KEY: 84,
        PATH: "supplier",
        ELEMENT: AllSupplier,
      },

      {
        TITLE: "Purchase",
        KEY: 85,
        PATH: "purchase",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Purchase",
            KEY: 851,
            PATH: "all-purchase",
            ELEMENT: AllPurchase,
          },
          {
            TITLE: "Add Purchase",
            KEY: 852,
            PATH: "add-purchase",
            ELEMENT: AddPurchase,
          },
          {
            TITLE: "Edit Purchase",
            KEY: 853,
            PATH: "edit-purchase/:ID",
            ELEMENT: AddPurchase,
          },
        ],
      },
      {
        TITLE: "Release",
        KEY: 84,
        PATH: "release",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Release",
            KEY: 841,
            PATH: "all-release",
            ELEMENT: AllRelease,
          },
          {
            TITLE: "Add Release",
            KEY: 842,
            PATH: "add-release",
            ELEMENT: AddRelease,
          },
        ],
      },
    ],
  },
  {
    TITLE: "Clinical settings",
    ICON: SettingsIcon,
    KEY: 7,
    PATH: "clinical-settings",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Manage Time",
        KEY: 71,
        PATH: "manage-time",
        ELEMENT: Managetime,
      },
      {
        TITLE: "Manage Print",
        KEY: 72,
        PATH: "manage-print",
        ELEMENT: ManagePrint,
      },
      {
        TITLE: "Manage Purpose",
        KEY: 73,
        PATH: "manage-purpose",
        ELEMENT: ManagePurpose,
      },
      {
        TITLE: "Treatments & Price List",
        KEY: 74,
        PATH: "treatment-price-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Treatment",
            KEY: 741,
            PATH: "all-treatment",
            ELEMENT: TreatmentAllList,
          },
          {
            TITLE: "Deactive Treatment",
            KEY: 742,
            PATH: "deactive-treatment",
            ELEMENT: DeactiveTreatmentList,
          },
        ],
      },
      {
        TITLE: "Diagnosis List",
        KEY: 75,
        PATH: "diagnosis-list",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "Active",
            KEY: 751,
            PATH: "active-diagnosis",
            ELEMENT: DiagnoseList,
          },
          {
            TITLE: "Add Diagnose",
            KEY: 752,
            PATH: "add-diagnose",
            ELEMENT: AddDiagnose,
          },
        ],
      },
      {
        TITLE: "Drugs",
        ICON: LocalPharmacyIcon,
        KEY: 76,
        PATH: "drugs",
        ELEMENT: Drugs,
      },
      {
        TITLE: "Booking",
        ICON: BookOnlineIcon,
        KEY: 77,
        PATH: "booktreatment",
        ELEMENT: ClinicManagementPage,
      },
    ],
  },

  {
    TITLE: "Staff",
    ICON: GroupsIcon,
    KEY: 5,
    PATH: "staff",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Employee",
        ICON: GroupsIcon,
        KEY: 52,
        PATH: "employee",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Employees",
            KEY: 521,
            PATH: "all-employees",
            ELEMENT: Employees,
          },
        
          {
            TITLE: "Deactive Employee",
            KEY: 522,
            PATH: "deactive-employee",
            ELEMENT: DeactiveEmployee,
          },
          {
            TITLE: "Add Employee",
            KEY: 523,
            PATH: "add-employee",
            ELEMENT: AddEmployee,
          },
          {
            TITLE: "Edit Employee",
            KEY: 523,
            PATH: "edit-employee/:ID",
            ELEMENT: AddEmployee,
            DISABLED: true,
          },
        ],
      },
      {
        TITLE: "Role",
        ICON: AdminPanelSettingsIcon,
        KEY: 51,
        PATH: "role",
        DIRECT: true,
        SUBNAV: [
          {
            TITLE: "All Roles",
            KEY: 511,
            PATH: "all-role",
            ELEMENT: Roles,
          },
          {
            TITLE: "Deactive Role",
            KEY: 512,
            PATH: "deactive-role",
            ELEMENT: DeactiveRole,
          },
          {
            TITLE: "Add Role",
            KEY: 513,
            PATH: "add-role",
            ELEMENT: AddRole,
          },
          {
            TITLE: "Edit Role",
            KEY: 514,
            PATH: "edit-role/:ID",
            ELEMENT: AddRole,
            DISABLED: true,
          },
        ],
      },
   
    ],
  },

];
